;(function ($) {
  /* ====================== FRAME ===================== */
  let editorActive = false

  /* ==================  EDITOR LOADER ================ */
  let frame = {
    sectionOpen: {
      newsletter: function () {
        newsletterPopup()
      },
      exitintent: function () {}
    },

    sectionClose: {
      newsletter: function () {
        ctaModal("close")
      },
      exitintent: function () {
        ctaModal("close")
      }
    },

    blockOpen: {
      meganav: function (editing, param) {
        meganav(editing, param)
      }
    },

    blockClose: {
      meganav: function (editing, param) {
        meganav(editing, param)
      }
    }
  }

  /* =================== EDITOR INIT =================== */
  /* DO SOMETHING WHEN SECTIONS IS ACTIVE */
  $(document).on("shopify:section:load", function () {
    editorActive = true
  })

  /* SECTION OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on("shopify:section:select", function (evt) {
    editorActive = true

    let sectionName = evt.detail.sectionId
    if (frame.sectionOpen[sectionName]) {
      frame.sectionOpen[sectionName]()
    }
  })

  /* SECTION CLOSED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on("shopify:section:deselect", function (evt) {
    editorActive = true

    let sectionName = evt.detail.sectionId
    if (frame.sectionClose[sectionName]) {
      frame.sectionClose[sectionName]()
    }
  })

  /* BLOCK OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on("shopify:block:select", function (evt) {
    editorActive = true

    let sectionName = evt.detail.sectionId,
      blockEl = $(evt.target)

    if (frame.blockOpen[sectionName]) {
      frame.blockOpen[sectionName](blockEl, "editing")
    }
  })

  /* BLOCK CLOSED: CHECK THE CLOSED LIST AND DO SOMETHING */
  $(document).on("shopify:block:deselect", function (evt) {
    editorActive = true

    let sectionName = evt.detail.sectionId
    let blockEl = $(evt.target)

    if (frame.blockClose[sectionName]) {
      frame.blockClose[sectionName](blockEl, "close")
    }
  })

  /* ================== FRONTEND LOADER ================ */
  function themeInit() {
    // CORE MODULE INIT'S
    swatches()

    // CUSTOM MODULE INIT'S
    newsletterPopup()
    matchHeightGrid()
    meganav()
  }

  themeInit()

  /* ==================== GLOBAL CTA =================== */
  function ctaModal(selector, cName, type) {
    let cookieName = cName
    let cookieType = type
    let $selector = $(selector)

    setTimeout(function () {
      if (modalState == false) {
        if (!Cookies.get(cookieName) || editorActive == true || cName == null) {
          modalState = cName
          $selector.addClass("cta--show")
          setTimeout(function () {
            $selector.addClass("cta--animate")
          }, 150)
        }
      }
    }, 600)

    if (selector == "close") {
      $(".cta").each(function () {
        $(this).removeClass("cta--animate")
        setTimeout(function () {
          $(this).removeClass("cta--show")
        }, 1500)
      })
    }

    function ctaClose(el) {
      if (cookieType == "temporary") {
        Cookies.set(cookieName, "close-" + cookieName, { expires: 1, path: "/" })
      } else {
        Cookies.remove(cookieName)
        setTimeout(function () {
          Cookies.set(cookieName, "permenant-" + cookieName, { expires: 365, path: "/" })
        }, 150)
      }
      modalState = false
      $selector.removeClass("cta--animate")
      setTimeout(function () {
        $selector.removeClass("cta--show")
      }, 1500)
    }

    if (cookieType == "permenant") {
      ctaClose()
    }
    $selector.find(".cta__close").on("click", function () {
      ctaClose($selector)
    })
  }

  /* ================= AJAX NEWSLETTER ================= */
  function newsletterPopup() {
    ctaModal("#newsletter__cta", "newsletter")

    $("#mc-embedded-subscribe").on("submit", function (e) {
      e.preventDefault()

      let $content = $(".cta .cta__content-inner .cta__content")

      $.ajax({
        type: $(this).attr("method"),
        url: $(this).attr("action"),
        data: $(this).serialize(),
        cache: false,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          console.log(
            "Could not connect to the registration server. Please try again later, or contact hello@wemakewebsites.com"
          )
        },
        success: function (data) {
          if (data.result != "success") {
            $content.append(
              '<span class="error">Sorry, this email is either incorrect or already exists on our system</span>'
            )
          } else {
            setTimeout(function () {
              $content.html(
                '<span class="h1">Thank You</span><h2>An email has been sent to you to confirm your registration.</h2>'
              )
            }, 250)
            setTimeout(function () {
              ctaModal("#newsletter__cta", "newsletter", "permenant")
            }, 2900)
          }
        }
      })
    })

    $("#mc-embedded-subscribe-footer").on("submit", function (e) {
      e.preventDefault()

      let $this = $(this)

      $.ajax({
        type: $(this).attr("method"),
        url: $(this).attr("action"),
        data: $(this).serialize(),
        cache: false,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          console.log(
            "Could not connect to the registration server. Please try again later, or contact hello@wemakewebsites.com"
          )
        },
        success: function (data) {
          if (data.result != "success") {
            $this.append(
              '<span class="error">Sorry, this email is either incorrect or already exists on our system</span>'
            )
          } else {
            setTimeout(function () {
              $this.html(
                "Thank You. An email has been sent to you to confirm your registration."
              )
            }, 250)
          }
        }
      })
    })

    /* WORKING */
    $("#mc-embedded-subscribe-preorder").on("submit", function (e) {
      e.preventDefault()

      let $this = $(this)

      $.ajax({
        type: $(this).attr("method"),
        url: $(this).attr("action"),
        data: $(this).serialize(),
        cache: false,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          console.log(
            "Could not connect to the registration server. Please try again later, or contact hello@wemakewebsites.com"
          )
        },
        success: function (data) {
          if (data.result != "success") {
            $this.append(
              '<span class="error">Sorry, this email is either incorrect or already exists on our system</span>'
            )
          } else {
            setTimeout(function () {
              $this.html(
                "Thank You. An email has been sent to you to confirm your registration."
              )
            }, 250)
          }
        }
      })
    })
  }
  /* /WORKING */

  let showNav
  let hideNav

  function showMegaNav(selector) {
    clearTimeout(hideNav)
    showNav = setTimeout(function () {
      selector.addClass("meganav__show")
    }, 500)
  }

  function hideMegaNav(selector, delay) {
    clearTimeout(showNav)
    showNav = setTimeout(function () {
      selector.removeClass("meganav__show")
    }, delay)
  }

  function openMegaNavs(selector) {
    selector.addClass("meganav__open")
  }

  function closeMegaNavs(selector) {
    selector.removeClass("meganav__open")
    selector.removeClass("meganav__in")
  }

  /* ================= MATCH HEIGHT - MAKE IMAGES IN A GRID SAME HEIGHT ================= */
  function matchHeightGrid() {
    $(document).ready(function () {
      $(".grid_sizer").matchHeight()
    })
  }

  /* ================= MEGA NAV ================= */
  function meganav(editing, param) {
    let $siteNavList = $(".site-nav li")
    let $siteDropdown = $(".meganav")
    let $siteHeader = $(".site-header")
    let $allMegaNavs = $("#shopify-section-meganav")

    /* SHOW IF EDITING */
    if (editing) {
      if (param == "editing") {
        editing.addClass("meganav__show")
      } else {
        editing.removeClass("meganav__show")
      }
    }

    $siteNavList.on("mouseenter", function (evt) {
      let $parentId = $(this).data("meganav-parent")
      let $dropdownList = $(".meganav")

      hideMegaNav($dropdownList, 500)
      if (!$allMegaNavs.hasClass("meganav__open")) {
        closeMegaNavs($allMegaNavs)
      }

      $dropdownList.each(function () {
        let $childId = $(this).data("meganav-child")
        if ($parentId == $childId) {
          let self = $(this)
          showMegaNav(self)
          openMegaNavs($allMegaNavs)
        }
      })
    })

    $siteDropdown.on("mouseenter", function (evt) {
      $allMegaNavs.addClass("meganav__in")
    })

    $siteHeader.on("mouseenter", function (evt) {
      hideMegaNav($siteDropdown, 0)
      closeMegaNavs($allMegaNavs)
    })

    $siteDropdown.on("mouseleave mousedown", function (e) {
      // Right Click Patch
      if (e.type != "mousedown" && e.originalEvent.buttons != 2) {
        // $(this).removeClass('meganav__show');
        let self = $(this)
        let in_delay = $allMegaNavs.hasClass("meganav__in") ? 0 : 500

        // toggleMeganav.hide(self);
        hideMegaNav(self, in_delay)
        closeMegaNavs($allMegaNavs)
      }
    })
  }
  /* ================= SWATCHES ================= */
  function swatches() {
    $(document).ready(function () {
      $(".swatch").on("click", function () {
        $(this).find("input").prop("checked", true).trigger("change")
      })
    })
  }

  $("[data-js-spa-read-more]").click(function () {
    opeSpaPopUp(this)
    return false
  })

  $("[data-js-spa-book-now]").click(function (e) {
    let $this = $(this)
    let title = $($this.parents("[data-js-spa-treatment-info]")).data(
      "spa-treatment-title"
    )

    if (
      (BrowserDetect.browser == "Explorer" && BrowserDetect.version < 11) ||
      title == "The Root Treatment Facial"
    ) {
      opeSpaPopUp(this)
      return false
    }
  })

  function opeSpaPopUp(obj) {
    let $this = $(obj)
    let $treatment = $($this.parents("[data-js-spa-treatment-info]"))
    let title = $treatment.data("spa-treatment-title")

    type = $treatment.data("spa-treatment-type")
    ;(desc = $treatment.find("[data-spa-treatment-desc]").html()),
      (img = $treatment.data("spa-treatment-img")),
      (link = $treatment.data("spa-treatment-link")),
      (price = $treatment.data("spa-treatment-price")),
      (time = $treatment.data("spa-treatment-time")),
      (phoneBooking = $this.parent().hasClass("phone-booking"))

    if (
      title == "The Root Treatment Facial" ||
      (BrowserDetect.browser == "Explorer" && BrowserDetect.version < 11)
    ) {
      $("[data-js-spa-pop-up--booking-message]")
        .html("Please call to book at (212) 227-1088.")
        .show()
      $("[data-js-spa-pop-up--link]").hide()
    } else {
      $("[data-js-spa-pop-up--booking-message]").html("").hide()
      $("[data-js-spa-pop-up--link]").attr("href", link).show()
    }

    $("[data-js-spa-pop-up--title]").html(title)
    $("[data-js-spa-pop-up--type]").html(type)
    $("[data-js-spa-pop-up--desc]").html(desc)
    $("[data-js-spa-pop-up--price]").html(price)
    $("[data-js-spa-pop-up--time]").html(time)
    $("[data-js-spa-pop-up--img]").css("background-image", "url(" + img + ")")

    ctaModal("#spa__cta", null)
  }

  $("[data-js-spa-pop-up--link]").click(function () {
    url = $(this).attr("href")
    window.location.href = url
  })

  $.onCreate(
    ".snize-description",
    function (elements) {
      // This removes 'Product Tagline' from the instant search results

      let $desc = $(".snize-description")

      $.each($desc, function (index, value) {
        let $this = $($desc[index]),
          html = $this.html().replace("Product Tagline ", "")

        $this.html(html)
      })
    },
    true
  )

  $("#AddToCart-product-template-spa").click(function () {
    if (
      $("#startTime").val() == "" ||
      $("#endTime").val() == "" ||
      $("#startTime").val() == undefined ||
      $("#endTime").val() == undefined
    ) {
      return false
    } else {
      //This prevents the user from adding multiple spa appointments of the same treatment to the cart
      $("#product-booking-overlay").show()
    }
  })
})(jQuery)
